'use strict';




export default function setupAddToCart () {
    const addToCartForms = document.querySelectorAll('form.add-to-cart');
    if ( !addToCartForms ) return;

    const addToCart = form => evt => {
        evt.preventDefault();

        const data = Object.fromEntries(new FormData(form));

        if ( form.dataset.type && form.dataset.type === 'update' ) {
            window.store.product.updateCart(data);
        } else {
            window.store.product.addToCart(data);
        }
    }

    addToCartForms
        .forEach(form => {
            if ( !form.dataset.active ) {
                form.addEventListener('submit', addToCart(form));
                form.dataset.active = true;
            }
        });
}
